var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shop"}},[_c('HoriTitle',{attrs:{"firstTitle":'内衣商城',"secondTitle":'UNDERWEAR MALL'}}),_vm._v(" "),_c('Gallery',{attrs:{"list":_vm.shop.list}}),_vm._v(" "),_c('Pagination',{attrs:{"total":_vm.shop.total},on:{"curPageChange":_vm.updatePage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ecf1d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Shop.vue
// module id = null
// module chunks = 